module.exports = __webpack_public_path__ + "static/media/BM_Sales.8c36c4a9.svg";